<script lang="ts">
  import {CatalystApp} from 'Catalyst/components/CatalystApp';
  import Carousel from 'Catalyst/components/Carousel/Carousel.svelte';
  import CarouselCard from 'Catalyst/components/CarouselCard/CarouselCard.svelte';
  import IncentiveTierCardContent from 'Components/InvestorFlow/v2/Components/ProductPageDetails/IncentiveTierCardContent.svelte';
  import {type GroupedTierEntries} from 'Types/incentiveTier/incentiveTierTypes';
  import {whiteLabeling} from 'Store/WhiteLabelStore';
  import type {CssColor} from 'Catalyst/utility/theme';

  export let groupedIncentiveTiers: GroupedTierEntries = [];

  const brandColor = $whiteLabeling.primary_color as CssColor;
</script>

{#if groupedIncentiveTiers.length > 0}
  <CatalystApp
    brandColors={[
      {
        key: 'brand-color',
        value: brandColor,
      },
    ]}
  >
    {#each groupedIncentiveTiers as [tierType, incentiveTiers] (tierType)}
      <div
        class="pb-[1rem] [&:not(:first-child)]:pt-[1rem] [&:not(:last-child)]:border-b border-solid border-[color:var(--palettes-neutral-75)]"
      >
        {#if incentiveTiers.length > 1}
          <Carousel>
            {#each incentiveTiers as incentiveTier}
              <CarouselCard>
                <IncentiveTierCardContent {incentiveTier} />
              </CarouselCard>
            {/each}
          </Carousel>
        {/if}
        {#if incentiveTiers.length === 1}
          <div
            class="border-[0.063rem] border-[--palettes-brand-color-500] border-solid bg-[#ffffff] rounded-[1rem]"
          >
            <IncentiveTierCardContent incentiveTier={incentiveTiers[0]} />
          </div>
        {/if}
      </div>
    {/each}
  </CatalystApp>
{/if}
